<template>
     <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li class="currentNode"><a>全站搜索</a></li>
            </ul>
            <div class="page-main">
                <div class="page-content">
                    <div class="search-div-wrapper">
                        <h3>全站搜索</h3>
                        <div class="search-div">
                            <el-select v-model="modelType" placeholder="请选择" clearable>
                                    <el-option
                                        v-for="item in modelTypeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                                <el-input placeholder="请输入内容" v-model="fullTextSearchValue" @keyup.enter.native="confirmFilter()">
                                    <el-button slot="append" type="primary" class="search-btn" @click="confirmFilter()">搜索</el-button>
                                </el-input>
                        </div>
                    </div>
                    <div class="result-wrapper">
                        <div class="result">
                            <div class="total-div">
                                <p>已为您找到<span class="red">{{ total }}</span>条相关结果</p>
                            </div>
                            <el-table
                                :data="tableData"
            
                                :show-header="false"
                            >
                                <el-table-column
                                    label="内容">
                                    <template slot-scope="scope">
                                        <a class="table_a" @click="goDetail(scope.row)">
                                            <p class="ellipsis_one">
                                                <span class="text" v-html="scope.row.Title"></span>
                                                <span class="tag">{{ scope.row.Description }}</span>
                                            </p>
                                        </a>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="UpdateTime"
                                    label="日期"
                                    width="120">
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="total"
                                    @current-change="handleCurrentChange">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
</template>

<script>
import {
    getSearchKey
} from '@services/indexService.js';
export default {
    name: '',
    data() {
        return {
            fullTextSearchValue: '',
            total: 0,
            currentPage: 1,
            pageSize: 10,
            tableData: [],
            modelType: null,
            modelTypeList: [
                {
                    label: '动态要闻',
                    value: '1'
                },
                {
                    label: '驻京党建',
                    value: '2'
                },
                {
                    label: '共享信息',
                    value: '3'
                },
                {
                    label: '会员风采',
                    value: '4'
                },
                {
                    label: '驻京机构',
                    value: '5'
                },
                {
                    label: '驻京机构工作动态',
                    value: '6'
                },
                {
                    label: '会员企业工作动态',
                    value: '7'
                },
                {
                    label: '工作部活动',
                    value: '8'
                },
                {
                    label: '专家讲坛',
                    value: '9'
                },
                {
                    label: '医疗资源',
                    value: '10'
                },
                {
                    label: '医疗科普',
                    value: '11'
                },
                {
                    label: '项目展示',
                    value: '12'
                },
                {
                    label: '政策解读',
                    value: '13'
                },
                {
                    label: '会员企业风采',
                    value: '20'
                },
                {
                    label: '精彩瞬间',
                    value: '21'
                },
                {
                    label: '驻京美食',
                    value: '22'
                },
                {
                    label: '信息交流',
                    value: '23'
                }
            ],
        };
    },
    created() {
        if (this.$route.query.text) {
            this.fullTextSearchValue = this.$route.query.text;
        }
        if (this.$route.query.type) {
            this.modelType = this.$route.query.type;
        }
        this.getSearchKey();
    },
    methods: {
        confirmFilter() {
            this.currentPage = 1;
            this.getSearchKey();
        },
        getSearchKey() {
            this.updateUrl();
            let params = {
                current: this.currentPage,
                size: this.pageSize,
                title: this.fullTextSearchValue,
                policyType: this.modelType,
            };
            getSearchKey(params).then((res) => {
                console.log(res);
                if (res.Code == 1) {
                    this.tableData = res.Data;
                    this.total = res.Count;
                } else {
                    this.$message.error('请求失败');
                }
            });
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getSearchKey();
        },
        goDetail(data) {
            let path = '';
            let externalLinks = '';
            switch(data.PolicyType) {
                case 1: 
                    if (data.Description == '实时要闻') {
                        path = '/layout/association-trends-detail?type=1';
                    } else if(data.Description == '协会动态') {
                        path = '/layout/association-trends-detail?type=2';
                    } else{
                        path = '/layout/association-trends-detail?type=3';
                    }    
                    break;
                case 2: path = '/layout/association-party-detail';break;
                case 3: path = '/layout/share-info-item-detail';break;
                case 4: 
                    if (data.Description == '非物质文化遗产') {
                        path = '/layout/cultural-heritage-detail';
                    } else if(data.Description == '名特优产品') {
                        path = '/layout/good-product-detail';;
                    }   
                    break;
                case 5: path = '/layout/institution-detail';break;
                case 6: path = '/layout/share-info-item-detail?parentPage=1';break;
                case 7: path = '/layout/share-info-item-detail?parentPage=1';break;
                case 8: 
                    if (data.Remark == 1) { // 信息工作部
                        path = '/layout/enterprise-branch-detail?type=1';
                    } else if(data.Remark == 2) { // 双招双引工作部
                        path = '/layout/enterprise-branch-detail??type=2';
                    } else if(data.Remark == 2) { // 医药卫生工作部
                        path = '/layout/enterprise-branch-detail??type=3';
                    } else { // 企业工作部
                        path = '/layout/enterprise-branch-detail??type=4';
                    }
                    break;
                case 9: path = '/layout/export-forum-detail';break;
                case 10: externalLinks = data.Remark;break;
                case 11: path = '/layout/medical-science-detail';break;
                case 12: path = '/layout/project-detail';break;
                case 13: path = '/layout/policy-detail';break;
                case 14: path = '/layout/vip-detail?';break;
                case 21: path = '/layout/high-light-detail';break;
                case 22: path = '/layout/city-food-detail';break;
                case 23: externalLinks = data.Remark;break;
            }
            if (path === '') {
                if (externalLinks === null || externalLinks === '') {
                    this.$message.error('未找到对应页面！');
                } else {
                    window.open(externalLinks, '_blank');
                }
                
            } else {
                let newUrl = this.$router.resolve({
                        path: path,
                        query: {
                            id: data.Id,
                            page: 1,
                        }
                });
                window.open(newUrl.href, '_blank');
            }
        },
        updateUrl() {
            // 获取当前URL
            var url = window.location.href;
            // 修改query参数
            var newQuery = `text=${this.fullTextSearchValue}`;
            // 拼接新的URL
            var newUrl = url.split('?')[0] + '?' + newQuery ;
            // 修改地址栏URL
            history.pushState(null, null, newUrl);
        },
    },
};
</script>

<style scoped>
.page-content {
    width: 1280px;
    padding: 0;
    background: none;
}
.page-content h3 {
    text-align: center;
}
.table_a {
    cursor: pointer;
}
.search-div-wrapper {
    width: 100%;
    height: 172px;
    background: #fff;
    margin-bottom: 20px;
    padding-top: 30px;
}
.search-div {
    margin: 0 auto;
    width: 860px;
    padding-top: 30px;
    display: flex;
}
.search-div h3{
    font-family: 思源黑体 CN;
    font-size: 30px;
    line-height: 36px;
    letter-spacing: 0.04em;
    text-align: center;
    margin-bottom: 10px;
}
.result-wrapper {
    width: 100%;
    background: #fff;
    padding: 30px;
}
.result{
    width: 1220px;
}
.tag {
    padding: 4px 6px;
    background-color: #0090F0;
    color:#fff;
    font-size: 12px;
    margin-left: 10px;
}
.total-div {
    padding: 0 0 30px 12px;
}
.red {
    color: red;
}
.search-btn{
    background: #116EBA !important;
    border: 1px solid #116EBA !important;
    color:#fff !important;
    border-radius: 0 !important;
}
.search-btn:hover{
    border-color: #005091 !important;
    background-color: #005091 !important;
}
.el-table{
    margin-bottom: 20px;
}
.text {
    max-width: 1000px;
    overflow:hidden;
}
</style>
<style>
.el-input-group__append{
    border: 1px solid #116EBA;
}
.search-div .el-input-group__append{
    border: none;
}
.search-div .el-select {
    width: 225px;
    margin-right: 10px;
}
</style>